var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 786.82,
    height: 572.258,
    viewBox: "0 0 786.82 572.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_programming_re_kg9v",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 26.701,
    cy: 26.701,
    r: 26.701,
    transform: "translate(431.62 47.481)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M872.038,661.023c39.688-30.229,58.643-81.026,46.776-129.482q-.442-1.806-.934-3.6c-7.867-28.763-27.332-56.1-55.7-65.291-23.82-7.717-49.82-1.783-74.669-4.852-48.781-6.024-86.6-45.494-113.211-86.819s-47.062-87.583-82.422-121.724c-58.285-56.275-153.362-68.392-225.627-31.76s-118.3,117.9-116.334,198.9S299.964,574.818,369.793,615.9c25.652,15.093,55.321,25.785,84.848,22.044,25.62-3.246,48.9-17.013,74.4-21.1,40.091-6.426,79.927,11.7,114.6,32.824s68.17,46.16,107.574,55.952C789.478,715.131,836.88,687.8,872.038,661.023Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M815.016,219.191c-.87-.58-1.75-1.13-2.62-1.69a380.24,380.24,0,0,0-80.31-38.93l-6.54,90.22h-41.46V165.4c-2.61-.54-5.24-1.05-7.87-1.53v104.92h-49.27a102.27,102.27,0,0,1-102.27-102.27h0c-2.64.57-5.26,1.18-7.88,1.83v100.44h-40.13l-6.23-86.03a380.859,380.859,0,0,0-81.94,43.53c-.44.3-.88.61-1.31.91-2.21,1.55-4.39,3.13-6.56,4.73v344.19H498.9l-2.09-28.95-11.5-158.95H716.9l-11.5,158.95-2.09,28.95h116.96V222.671Q817.656,220.9,815.016,219.191ZM516.8,361.971h-33.39l-6.17-85.3H516.8Zm159.42,0h-56.08v-1.69a6.18,6.18,0,0,0-6.19-6.18h-24.38a6.178,6.178,0,0,0-6.18,6.18v1.69h-58.71v-85.3h151.54Zm7.87,0v-85.3h40.89l-6.17,85.3Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M206.59,598.162a289,289,0,0,0,28.12,28.95l730.58,1a288.993,288.993,0,0,0,28.12-28.95Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M702.02,505.462v85.7a4.122,4.122,0,0,0,4.119,4.119h127a4.122,4.122,0,0,0,4.119-4.119v-85.7a4.124,4.124,0,0,0-4.119-4.115h-127a4.124,4.124,0,0,0-4.119,4.115Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M705,506.529v83.58a2.205,2.205,0,0,0,2.2,2.2H832.086a2.205,2.205,0,0,0,2.2-2.2v-83.58a2.206,2.206,0,0,0-2.2-2.206H707.2a2.206,2.206,0,0,0-2.2,2.206Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M699.364,607.881a2.47,2.47,0,0,0,1.943.93H837.3a2.5,2.5,0,0,0,2.446-3.016l-2.111-10.027a2.507,2.507,0,0,0-1.558-1.818,2.423,2.423,0,0,0-.888-.168H703.41a2.425,2.425,0,0,0-.888.167,2.507,2.507,0,0,0-1.558,1.818L698.853,605.8a2.5,2.5,0,0,0,.511,2.086Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(627.632 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(619.255 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(610.878 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(602.501 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(594.124 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(585.747 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(577.37 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(568.993 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(560.616 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(552.239 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(543.862 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(535.485 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(527.109 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(518.732 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(510.355 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(501.978 434.231) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(627.731 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(619.354 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(610.977 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(602.6 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(594.223 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(585.846 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(577.469 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(569.092 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(560.715 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(552.338 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(543.961 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(535.584 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(527.207 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(518.831 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(510.453 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 4.188,
    height: 2.513,
    rx: 0.488,
    transform: "translate(502.077 438.419) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 33.508,
    height: 2.513,
    rx: 0.488,
    transform: "translate(587.522 443.445) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(515.631 358.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(548.154 358.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(557.369 358.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(524.477 358.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(567.841 358.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(524.304 365.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(556.827 365.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(566.042 365.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(533.15 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(576.514 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(532.977 372.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(565.5 372.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(574.715 372.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(541.823 372.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(585.187 372.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(541.649 379.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(574.172 379.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(583.387 379.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(550.496 379.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(548.154 407.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(557.369 407.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(567.841 408.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(515.631 407.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(524.477 408.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(524.304 400.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(556.827 400.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(566.042 400.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(533.15 401.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(532.977 393.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(565.5 393.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(574.715 393.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(541.823 394.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(541.649 386.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(574.172 386.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 5.966,
    height: 3.122,
    rx: 1.561,
    transform: "translate(583.387 386.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 20.796,
    height: 3.122,
    rx: 1.561,
    transform: "translate(550.496 387.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M711.507,654.353l-13.349-21.1,41.9-33.4,17.3-19.161a19.161,19.161,0,0,1,32.418,6.828h0a19.161,19.161,0,0,1-11.57,23.991l-27.349,10.075Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M398.28,501.352v102.56h71.85V501.352a3.448,3.448,0,0,0-2.43-3.3,3.175,3.175,0,0,0-1.03-.16H401.75a3.463,3.463,0,0,0-3.47,3.46Zm28.04,35.24a7.67,7.67,0,1,1,15.34,0v11.9a7.67,7.67,0,1,1-15.34,0Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M398.06,600.632v9.89a1.946,1.946,0,0,0,1.93,1.94h68.43a1.94,1.94,0,0,0,1.93-1.94v-9.89Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M285.25,346.832v187.26a9.007,9.007,0,0,0,9,9h277.5a9.007,9.007,0,0,0,9-9V346.832a9.011,9.011,0,0,0-9-8.99H294.25a9.012,9.012,0,0,0-9,8.99Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M291.76,349.162v182.62a4.818,4.818,0,0,0,4.81,4.81H569.44a4.818,4.818,0,0,0,4.81-4.81V349.162a4.82,4.82,0,0,0-4.81-4.82H296.57a4.82,4.82,0,0,0-4.81,4.82Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M342.4,611.792a2.948,2.948,0,0,0,2.32,1.11H507.06a2.987,2.987,0,0,0,2.92-3.6l-2.52-11.97a2.993,2.993,0,0,0-1.86-2.17,2.9,2.9,0,0,0-1.06-.2H347.23a2.894,2.894,0,0,0-1.06.2,2.992,2.992,0,0,0-1.86,2.17l-2.52,11.97A2.985,2.985,0,0,0,342.4,611.792Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M560.585,369.5H305.261a1.015,1.015,0,1,1,0-2.031H560.585a1.015,1.015,0,1,1,0,2.031Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.95,
    cy: 6.083,
    rx: 5.95,
    ry: 6.083,
    transform: "translate(110.101 186.247)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.95,
    cy: 6.083,
    rx: 5.95,
    ry: 6.083,
    transform: "translate(130.657 186.247)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 5.95,
    cy: 6.083,
    rx: 5.95,
    ry: 6.083,
    transform: "translate(151.213 186.247)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M548.206,351.622h-14.6a1.105,1.105,0,0,0,0,2.21h14.6a1.105,1.105,0,1,0,0-2.21Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M548.206,355.772h-14.6a1.105,1.105,0,1,0,0,2.21h14.6a1.105,1.105,0,1,0,0-2.21Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M548.206,359.922h-14.6a1.105,1.105,0,0,0,0,2.21h14.6a1.105,1.105,0,1,0,0-2.21Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M900.186,604.972a6.416,6.416,0,0,0,6.183,4.331l26.492-.682a6.329,6.329,0,0,0,5.981-4.657l3.749-40.087a9.794,9.794,0,0,0,4.238.871,9.661,9.661,0,0,0-.485-19.317,8.181,8.181,0,0,0-1.736.18,6.548,6.548,0,0,0-4.874-2.1l-40.75,1.052a5.851,5.851,0,0,0-1.005.125,6.365,6.365,0,0,0-4.873,8.265Zm43.174-43.817,2.668-9.553a6.507,6.507,0,0,0,.02-3.375c.13,0,.244-.062.373-.062a6.91,6.91,0,1,1,.323,13.817,6.5,6.5,0,0,1-3.385-.827Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M897.978,544.686c.868,4.964,10.629,8.454,22.366,7.847,10.793-.5,19.617-4.287,21.234-8.779a6.026,6.026,0,0,0-1.844-.246l-40.75,1.052A5.852,5.852,0,0,0,897.978,544.686Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M922.494,582.944a.5.5,0,0,0,.151-.066l5.753-3.766a.5.5,0,0,0,0-.836l-5.98-3.917a.5.5,0,0,0-.548.836l5.341,3.5-5.114,3.348a.5.5,0,0,0,.4.9Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M913.408,583.363a.5.5,0,0,0,.126-.918l-5.3-3.04,5.126-3.807a.5.5,0,1,0-.6-.8l-5.739,4.263a.5.5,0,0,0,.049.835l5.965,3.42A.5.5,0,0,0,913.408,583.363Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M921.922,586.244a.48.48,0,0,0,.137-.058.5.5,0,0,0,.167-.687l-8.155-13.408a.5.5,0,0,0-.854.521l8.155,13.408A.5.5,0,0,0,921.922,586.244Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 50.719,
    height: 10.846,
    rx: 3.264,
    transform: "translate(209.385 260.827)",
    fill: "#096f4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 102.236,
    height: 10.846,
    rx: 3.264,
    transform: "translate(183.626 282.519)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 102.236,
    height: 10.846,
    rx: 3.264,
    transform: "translate(183.626 304.21)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M497.3,540.717l.217.684.011.023,6.525,19.838,7.506,22.861,14.123,42.961.137,6.673v.023l1.049,53.685-2.909,7.278,3.274,11.932s-1.506-18.037-9.582-7.679c-4.574,5.886-9.925,11.91-14.317,17.556q9.6,3.884,19.507,7.027c1.426.456,2.863.89,4.3,1.323l.924.274A266.863,266.863,0,0,0,595.418,736c1.186.034,2.35.057,3.479.08.4.011.787.023,1.175.023,1.278.011,2.544.023,3.822.023q3.867,0,7.7-.114a266.85,266.85,0,0,0,56.091-7.586c-.125-7.586-.468-16.45-.958-25.918-.228-4.643-5.35-9.674-5.658-14.533-.217-3.65,4.381-7.084,4.141-10.792-1.551-22.827-3.491-14.064-4.928-30.229q-.222-2.379-.411-4.552c-.924-10.381-1.563-16.872-1.563-16.872l6.137-38.683,9.64-60.734-.742-1.221-.833-.411-50.844-25.165-2.761-7.073a10.979,10.979,0,0,0-10.141-6.947l-33.493-.137a10.931,10.931,0,0,0-8.909,4.529l-9.069,12.56Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M533.407,617.525l-7.587,16.233-5.179,11.088-8.909,46.646-4.46,4.734-3.821-16.759-40,8.881c-1.312-7.289-.351.247-1.161-7.75.228-.228.468-.456.707-.685.639-.593,1.175-1.152,1.164-1.688-.456-27.584.913-74.526,12.343-102.966a60.053,60.053,0,0,1,7.027-13.107c.228-.308.445-.616.662-.924,5.27-7.381,8.6-14.648,13.324-19.815V541.4a.532.532,0,0,0,.08-.08.157.157,0,0,0,.046-.034l32.443-17.2,1.392,39.105.992,28.109Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M650.391,622.135l9.476,20.275,3.307,7.061,8.907,46.642,4.446,4.723,3.83-16.755,1.8-.369,32.458-6.722,9.461,30.046a17.984,17.984,0,0,0-3.261-22.506c-.646-.585-1.184-1.154-1.169-1.692.538-32.443-1.446-91.684-19.367-116.066-5.692-7.738-9.107-15.445-14.076-20.829-.015-.015-.015-.031-.031-.031l-12.091-19.8-.738-1.215-.831-.415Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 44.558,
    cy: 44.558,
    r: 44.558,
    transform: "translate(341.839 222.643)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M653.212,399.948a3.759,3.759,0,0,0-2.69-1.19l.67-1.86a3.528,3.528,0,0,0-3.96-4.7l-2.44.47.23-1.63a3.534,3.534,0,0,0-4.73-3.82,3.766,3.766,0,0,1-3.24-.23,3.846,3.846,0,0,1-1.92-2.61l-.85-4.1-.09-.22c-4.14-6.9-12.1-11.92-21.84-13.76-8.67-1.65-17.56-.81-26.13-.02-3.4.32-7.24.68-10.44,2.64-2.72,1.68-5.02,5.04-4.55,8.43-8.45-2.59-17.51,2.58-22,9.1-5.32,7.76-6.19,17.48-6.33,25.08-.38,17.98,3.33,32.69,11,43.73.56.8.7,2.47,1.81,3.03l-.23-.37c1.24.62,2.5,1.62,2.03,2.69-1.35,3.08,7.62,9.89,13.94,12.14,11.53,4.11,26.86,3.76,37.64,2.28l.38-2.55c3.89-.53,6.63-1.54,7.4-3.12,1.36-1.16,2.52-2.2,3.53-3.16l.01-.01c.02-.02.06-.05.08-.07,4.87-4.67,6-7.33,6.51-11.38.49-3.97-.38-8-1.27-11.63,18.74,2.9-7.38-19.96,10.08-24.38a5.432,5.432,0,0,1,.61-.15c.51-.12,1.02-.24,1.51-.38a26.45,26.45,0,0,0,6.72-2.87c4.88-2.97,6.49-6.91,9.01-11.35a3.427,3.427,0,0,0-.45-4.03Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M750.582,625.308c-.01,1.75-.03,4.2-.11,7.23q-.015.63-.03,1.29c-.13,5.57-.26,10.24-.47,15.43-.01.36-.02.71-.04,1.07-.28,7.24-.72,15.67-1.48,29.02-1.41,24.66-3.87,3.39-6.34,12.04-.12.43-.25.94-.37,1.54a27.916,27.916,0,0,1-1.88,6.33c-1.31.78-2.66,1.53-3.99,2.28-3.79,2.11-7.64,4.14-11.52,6.07-2.18,1.08-4.37,2.14-6.57,3.16-.35.16-.69.32-1.03.47A270.9,270.9,0,0,1,682,724.5c-2.32.7-4.63,1.38-6.97,2.01-2.44.68-4.88,1.32-7.35,1.92a266.888,266.888,0,0,1-56.09,7.59c-2.55.08-5.12.11-7.7.11-1.28,0-2.54-.01-3.82-.02-.39,0-.78-.01-1.17-.02-1.13-.03-2.3-.05-3.48-.08a266.667,266.667,0,0,1-67.35-10.83l-.93-.27c-1.44-.44-2.87-.87-4.3-1.33q-9.9-3.135-19.51-7.02-7.335-2.955-14.5-6.34a.339.339,0,0,1-.12-.06c-1-.46-2.01-.94-3.01-1.43-.13-.07-.27-.14-.41-.21q-5.6-2.73-11.07-5.72c-3.07-7.05-7.39-8.4-10.07-14.6a25.873,25.873,0,0,1-1.68-5.74c0-.02-.01-.04-.01-.07.28,3.72-1.19-6.6-.01-.04-.01-.12-.02-.25-.03-.4-.03-.36-.07-.8-.13-1.35-3.43-33.49-3.21-71.79-4.7-103.35q-.15-3.06-.31-5.86c-.03-.62-.07-1.23-.11-1.83.07-.18.15-.37.24-.55a1,1,0,0,1,.07-.15,1.634,1.634,0,0,1,.1-.18c.02-.03.05-.07.07-.1a.9.9,0,0,1,.05-.1c.09-.14.19-.29.3-.43.05-.06.09-.11.14-.16a.808.808,0,0,1,.12-.14.636.636,0,0,1,.11-.13c.04-.04.08-.09.13-.14a.3.3,0,0,1,.08-.08,2.029,2.029,0,0,1,.26-.25,9.62,9.62,0,0,1,1.14-.9c.14-.09.29-.18.43-.28a19.134,19.134,0,0,1,3.17-1.52c.38-.14.76-.27,1.17-.41.15-.04.29-.09.44-.14.22-.07.44-.14.67-.19,1.14-.34,2.37-.63,3.7-.9.16-.03.33-.06.5-.1.24-.05.49-.09.74-.13.34-.06.69-.12,1.04-.18,2.97-.47,6.34-.82,10.06-1.05l1.05-.06,1.24-.06c.35-.02.71-.03,1.07-.04s.71-.03,1.08-.04c1.01-.03,2.05-.06,3.11-.08,3.02-.06,6.2-.04,9.54.03,1.55.04,3.13.08,4.75.15.11,0,.21.01.31.01,1.41.05,2.83.11,4.29.19,1.02.05,2.05.1,3.08.16.97.06,1.95.12,2.94.19.77.04,1.54.1,2.32.15.66.05,1.32.1,1.98.14l.9.06c.49.04.98.07,1.48.12,1.1.09,2.2.18,3.32.27s2.24.2,3.37.3,2.27.21,3.41.32l.34.03c1.04.11,2.08.21,3.13.32.24.02.49.04.73.07,1,.1,2.022.218,3.032.326l.929.1c.791.086,1.572.161,2.368.254,1.05.12,2.12.23,3.16.37.81.09,1.62.18,2.43.28,1.27.15,2.56.31,3.85.48.49.06.98.12,1.47.19,3.68.46,7.4.97,11.18,1.5,5.73.81,11.55,1.69,17.41,2.64s11.773,1.953,17.71,3.01c1.5.27,3,.54,4.51.82l2.04.39c1.16.21,2.32.43,3.48.65s2.32.44,3.48.67l4.15.81c9.09,1.8,18.13,3.72,26.95,5.73,1.45.33,2.9.67,4.34,1q4.32,1,8.56,2.04c.78.18,1.55.37,2.32.56,1.92.48,3.84.96,5.73,1.45l.33.09c1.39.34,2.75.69,4.11,1.05q4.815,1.26,9.47,2.55,3.09.855,6.11,1.73c3.01.87,5.96,1.75,8.83,2.64.71.22,1.42.44,2.12.65,2.1.65,4.17,1.31,6.18,1.97,1.6.52,3.16,1.05,4.7,1.58s3.05,1.06,4.53,1.59c.95.34,1.89.7,2.83,1.04,1.35.5,2.68,1,3.98,1.5.4.15.79.31,1.18.46.25.11.49.2.73.3.47.19.95.37,1.41.56s.93.37,1.39.57c.45.18.91.37,1.35.56s.89.37,1.33.57c.37.15.73.31,1.08.47.71.31,1.42.62,2.11.94.34.16.68.31,1.02.47l.78.36c.11.06.22.11.33.16.25.12.51.25.76.37.58.27,1.15.56,1.71.83.75.38,1.48.76,2.18,1.13s1.4.76,2.06,1.13c.11.06.21.12.32.18.15.08.3.17.45.25.51.29,1,.59,1.49.88.96.59,1.87,1.17,2.72,1.75.19.13.37.26.56.38.63.45,1.23.89,1.79,1.34,0,.01,0,.01.01.01.19.14.37.29.55.43.15.14.31.26.46.4.52.45,1,.88,1.44,1.32a5.674,5.674,0,0,1,.42.43,1.208,1.208,0,0,1,.16.16c.2.2.38.4.55.6a.556.556,0,0,1,.07.09c.24.28.46.56.67.84.1.14.21.28.3.42.12.17.24.35.34.52.09.14.17.29.25.43a7.261,7.261,0,0,1,.54,1.13,5.234,5.234,0,0,1,.27.82,5.857,5.857,0,0,1,.17.81Z",
    transform: "translate(-206.59 -163.871)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M750.582,625.308c-.01,1.75-.03,4.2-.11,7.23-.01.42-.03.85-.04,1.29-.1,4.25-.25,9.5-.46,15.43-.01.36-.02.71-.04,1.07-.28,7.24-.72,15.67-1.48,29.02-1.41,24.66-3.87,3.39-6.34,12.04-6.86-4.22-14.38-8.64-22.42-13.18q-2.175-1.23-4.39-2.47c-16.08-8.97-34.04-18.37-52.79-27.68-.74-.37-1.49-.74-2.23-1.1-42.95-21.23-89.83-41.88-127.81-55.66-7.33-2.66-14.33-5.06-20.91-7.17-13.86-4.43-25.84-7.53-35.06-8.87-9.6-1.4-16.23-.9-18.91,1.99q-.15-3.06-.31-5.86-.06-.93-.12-1.83c.062-.165.142-.322.22-.48.011-.023.019-.047.03-.07a1,1,0,0,1,.07-.15,1.618,1.618,0,0,1,.1-.18,1.063,1.063,0,0,1,.12-.2c.09-.14.19-.29.3-.43a3.488,3.488,0,0,1,.26-.3.636.636,0,0,1,.11-.13c.04-.04.08-.09.13-.14a.3.3,0,0,1,.08-.08,2.03,2.03,0,0,1,.26-.25,9.632,9.632,0,0,1,1.14-.9c.14-.09.29-.18.43-.28a19.133,19.133,0,0,1,3.17-1.52c.38-.14.76-.27,1.17-.41.15-.04.29-.09.44-.14.22-.07.44-.14.67-.19,1.14-.34,2.37-.63,3.7-.9.4-.08.82-.16,1.24-.23.34-.06.69-.12,1.04-.18,2.97-.47,6.34-.82,10.06-1.05l1.05-.06,1.24-.06c.35-.02.71-.03,1.07-.04s.71-.03,1.08-.04c1.01-.03,2.05-.06,3.11-.08,3.02-.05,6.2-.03,9.54.04,1.55.03,3.13.08,4.75.15.1,0,.21.01.31.01,1.41.04,2.84.11,4.29.18,1.02.05,2.05.1,3.08.16.97.06,1.95.12,2.94.19.77.04,1.54.1,2.32.15.66.05,1.32.1,1.98.14l2.38.18c1.1.09,2.2.18,3.32.27s2.24.2,3.37.3,2.27.21,3.41.32l.34.03c1.04.11,2.08.21,3.13.32q8.73.885,17.97,2.07,5.52.705,11.18,1.51c5.73.81,11.55,1.69,17.41,2.63s11.773,1.953,17.71,3.01c1.5.27,3,.54,4.51.82q2.76.51,5.52,1.04c1.16.22,2.32.44,3.48.67l4.15.81c9.09,1.8,18.13,3.72,26.95,5.73,1.45.33,2.9.67,4.34,1q4.32,1,8.56,2.04c.78.19,1.55.38,2.32.57q2.895.72,5.73,1.44v.01c.11.02.22.05.33.08,1.38.35,2.75.7,4.11,1.06q4.815,1.26,9.47,2.54c2.06.58,4.1,1.15,6.11,1.73,3.01.88,5.96,1.76,8.83,2.64.71.22,1.42.44,2.12.65q3.15.99,6.18,1.97c1.6.52,3.16,1.05,4.7,1.58s3.05,1.06,4.53,1.59c.96.34,1.9.69,2.83,1.03,1.36.5,2.68,1,3.98,1.51.4.15.79.31,1.18.46.73.28,1.44.57,2.14.86.47.18.93.37,1.39.57.45.18.91.37,1.35.56s.89.37,1.33.57c.37.15.73.31,1.08.47.71.31,1.42.62,2.11.94.34.16.68.31,1.02.47l.78.36c.11.06.22.11.33.16.85.4,1.67.8,2.47,1.2.75.38,1.48.76,2.18,1.13.83.44,1.62.87,2.38,1.31.15.08.3.17.45.25.51.29,1,.59,1.49.88.96.59,1.87,1.17,2.72,1.75s1.62,1.15,2.35,1.72c0,.01,0,.01.01.01.35.28.69.56,1.01.83.52.45,1,.88,1.44,1.32a5.674,5.674,0,0,1,.42.43,1.2,1.2,0,0,1,.16.16c.21.23.42.46.62.69.24.28.46.56.67.84.1.14.21.28.3.42.12.17.24.35.34.52.09.14.17.29.25.43a7.264,7.264,0,0,1,.54,1.13,6.048,6.048,0,0,1,.27.82,5.846,5.846,0,0,1,.17.81Z",
    transform: "translate(-206.59 -163.871)",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no-content.a293be1d0492fc9613220277de0403f5.svg";
export { ForwardRef as ReactComponent };